/**
 * created by xcc
 * 阵地安全管理查看详情
 *
 */
import React from 'react';
import TableTemplate from "../../../components/TableTemplate/TableTemplate";
import PaginationTemplate from "../../../components/PaginationTemplate/PaginationTemplate";
import {Row, Col, Button, Modal, Checkbox} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {getMaxWidth} from "../../../../statisticalAnalysis/statisticsTable//utils";
import PageTemplate from "../../../components/pageTemplate/PageTemplate";
import {formatTime} from "../../../../../utils";
import {getPmsBatchConfig, getPmsDetailBottomBtn, getPmsDetailListBtn} from "../safetyManageConfig";
import Remark from "./remark";
import Preview from "./contentView/preView";
import {message} from "../../../../../utils/message";
import ViewContentText from "./viewContentText";
import {getAllPositionTypeData} from "../../../../newMediaMatrix/actions/actions";
import { CUSTOM_CONFIG } from '../../../../../config/customConfig';

export default class Detail extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            dataSource: [],
            detailData: {},
            toggleStatus: false
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getTitle() {
        const {typeData=this.state.typeData} = this.props;
        let clickTypeObj = (typeData && typeData.find(item => item.id === this.state.detailData.positionTypeId)) || {};
        let code = clickTypeObj.code;
        const clickLink = () => {
            window.open(this.state.detailData.url);
        }
        const value1 = <div style={{display: "flex", alignItems: 'center'}}>
            <div style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}} onClick={() => clickLink()}>原文链接</div>
            <div style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}} onClick={() => {
                this.preview.openModal(this.state.detailData)
            }}>查看快照</div>
        </div>
        const value2 = <div style={{display: "flex", alignItems: 'center'}}>
            <div style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}} onClick={() => clickLink()}>原文链接</div>
        </div>;
        switch (code) {
            case "wz": return value2;
            default: return value1;
        }
    }

    getLeftDetailHeaderFields() {
        return [
            {
                col: 10,
                id: "title", // 标签id
                labelName: "稿件标题", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.title, // 值
            },
            {
                col: 6,
                id: "time", // 标签id
                labelName: "检测时间", // 标签名
                labelCode: "title", // 标签key
                value: formatTime(this.state.detailData.checkTime), // 值
            },
            {
                col: 5,
                id: "belongDept", // 标签id
                labelName: "所属账号", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.positionName, // 值
            },
            {
                col: 5,
                id: "mainDept", // 标签id
                labelName: "主责单位", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.mainDeptName, // 值
            },
            {
                col: 5,
                id: "leader", // 标签id
                labelName: "负责人", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.leader, // 值
            },
            {
                col: 6,
                id: "tel", // 标签id
                labelName: "联系电话", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.contact, // 值
            },
            {
                col: 5,
                id: "link", // 标签id
                labelName: "", // 标签名
                labelCode: "link", // 标签key
                value: this.getTitle(), // 值
            },
        ]
    }

    getRightDetailHeaderFields() {
        return [
            {
                col: 24,
                id: "disposeStatusName", // 标签id
                labelName: "处理状态", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.disposeStatusName, // 值
            },
            {
                col: 24,
                id: "remindStatus", // 标签id
                labelName: "提醒状态", // 标签名
                labelCode: "title", // 标签key
                value: this.state.detailData.remindStatusName, // 值
            },
            {
                col: 24,
                id: "errorCount", // 标签id
                labelName: "错敏数量", // 标签名
                labelCode: "title", // 标签key
                // value: `${this.state.detailData.securityProcessedCount}/${this.state.detailData.securityAllCount}`, // 值
                value: <div><span
                    style={{color: this.state.detailData.securityProcessedCount === 0 ? "#89D069" : "#F56C6C"}}>{this.state.detailData.securityProcessedCount}</span>/<span>{this.state.detailData.securityAllCount}</span>
                </div>, // 值
            },
        ]
    }

    getDangerDisposeList() {
        let {dangerDisposeList = []} = this.state.detailData;
        let newArr = [];
        dangerDisposeList?.length && dangerDisposeList.map(item => {
            newArr.push(
                {
                    col: 5,
                    id: "userName", // 标签id
                    labelName: "处置人", // 标签名
                    labelCode: "title", // 标签key
                    value: item.userName, // 值
                },
                {
                    col: 5,
                    id: "userNumber", // 标签id
                    labelName: "手机号", // 标签名
                    labelCode: "title", // 标签key
                    value: item.userNumber, // 值
                },
                {
                    col: 11,
                    id: "userEmail", // 标签id
                    labelName: "邮箱号", // 标签名
                    labelCode: "title", // 标签key
                    value: item.userEmail, // 值
                },
            )
        })
        return newArr
    }

    callBack = () => {}

    getAllPositionTypeDataFun() {
        getAllPositionTypeData({}, (data) => {
            let typeData = [];
            if (data && data.length) {
                typeData = data.map(item => {
                    return {
                        ...item,
                        key: item.id
                    }
                })
            }
            this.setState({
                typeData
            })
        })
    }

    show(id, callBack) {
        if(!this.props.typeData?.length) {
            this.getAllPositionTypeDataFun()
        }
        this.callBack = callBack;
        this.request({
            url: '/cm-sites-media-consumer/safety/management/getById',
            body: {id},
            callBack: (data) => {
                let detailData = {};
                if (data) {
                    detailData = data;
                }
                this.setState({
                    detailData,
                    visible: true,
                    remarkVisible: detailData?.disposeStatus === 3 && detailData?.remarkInfos?.length ? true : false
                })
            },
            errorCallBack: (e) => {
            },
        })
    }

    // 单个修改状态
    refreshDetailListData(record, btnItem) {
        let positionSecurityItem = (this.state.detailData?.positionSecurityList?.length && this.state.detailData.positionSecurityList.find(item => record.id === item.id)) || [];
        positionSecurityItem["disposeStatus"] = btnItem.statusValue;
        positionSecurityItem["disposeStatusName"] = btnItem.statusName;
        this.setState({})
    }

    // pms批量修改状态
    pmsBatchHandle(record, btnItem) {
        this.state.detailData?.positionSecurityList?.length && this.state.detailData.positionSecurityList.map(item => {
            item["disposeStatus"] = btnItem.statusValue;
            item["disposeStatusName"] = btnItem.statusName;
        })
        this.setState({})
    }

    renderHeader() {
        const leftDetailHeaderFields = this.getLeftDetailHeaderFields();
        const rightDetailHeaderFields = this.getRightDetailHeaderFields();
        const dangerDisposeList = this.getDangerDisposeList();
        return (
            <>
                <Row>
                    <Col span={21}>
                        {leftDetailHeaderFields.map((item, index) => {
                            return this.renderItem(item, index);
                        })}
                        {dangerDisposeList.map((item, index) => {
                            return this.renderItem(item, index);
                        })}
                    </Col>
                    <Col span={3}>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            {rightDetailHeaderFields.map((item, index) => {
                                return this.renderItem(item, index);
                            })}
                        </div>
                    </Col>
                </Row>
            </>
        )
    }

    renderItem({col, id, labelName, value}, index) {
        return (
            <Col span={col} key={id+index} className={"fieldsCol"}>
                <div style={{display: "flex"}}>
                    {labelName && <div style={{color: "#000", maxWidth: 120}}>{labelName}：</div>}
                    <div title={typeof value === 'string' ? value : ''} style={{
                        overflow: "hidden",
                        textOverflow: 'ellipsis',
                        whiteSpace: "nowrap",
                        maxWidth: 410
                    }}>{value || value !=="" ? value : "-"}</div>
                </div>
                <style>{`.fieldsCol {padding-bottom: 10px;}`}</style>
            </Col>
        )
    }

    getColumns() {
        return (
            [
                {
                    title: "疑似错误",
                    dataIndex: "word",
                    key: "word",
                    width: 250,
                    ellipsis: true
                },
                {
                    title: "建议操作",
                    dataIndex: "correct",
                    key: "correct",
                    width: 200,
                    ellipsis: true
                },
                {
                    title: "预警类型",
                    dataIndex: "securityTypeName",
                    key: "securityTypeName",
                    ellipsis: true,
                    width: 100,
                },
                {
                    title: "",
                    dataIndex: "category",
                    key: "category",
                    ellipsis: true,
                    width: 150,
                },
                {
                    title: "所在句子",
                    dataIndex: "sentence",
                    key: "sentence",
                    ellipsis: true,
                    width: 250,
                    render: (text, record) => {
                        return (
                            <>
                                <div style={{display: "flex"}}>
                                    <div title={text} style={{maxWidth: 240, overflow: "hidden", textOverflow: 'ellipsis', whiteSpace: "nowrap"}}>{text}</div>
                                    {text && <div style={{color: "#1082ff", cursor: "pointer"}}
                                          onClick={() => this.viewContent(record)}> 查看</div>}
                                </div>
                            </>
                        )
                    }
                },
                {
                    title: "处理状态",
                    dataIndex: "disposeStatusName",
                    key: "disposeStatusName",
                    ellipsis: true,
                    width: 170,
                }
            ]
        )
    }

    viewContent = (record) => {
        this.viewContentText.show(record);
    }

    getOperate() {
        const onToggleClick = () => {
            this.setState({
                toggleStatus: !this.state.toggleStatus
            })
        }
        let batchConfig = this.getBatchConfig();
        let show = batchConfig?.child && batchConfig.child.length > 0;
        let title = <span>操作{show ? <span style={{color: "#1082ff", cursor: "pointer"}} onClick={onToggleClick}>（{batchConfig.name}）</span> : ""}</span>
        return {
            title: title,
            dataIndex: "operation",
            key: "operation",
            render: (text, record) => {
                return (
                    <>
                        {this.renderPmsDetailListButton(record)}
                    </>
                );
            }
        }
    }

    getBatchConfig = () => {
        return null;
        // return getPmsBatchConfig(this.state.detailData?.disposeStatus);
    }

    // 全选
    onCheckboxClick = (checked) => {
        let {detailData} = this.state;
        if (detailData?.positionSecurityList?.length) {
            if (checked) {
                detailData.positionSecurityList.forEach(item => {
                    // 已忽略  跟核验通过的数据不许批量操作
                    if(item.disposeStatus === 0 || item.disposeStatus === 3) {
                        item.checked = false
                    } else {
                        item.checked = true;
                    }
                });
            } else {
                detailData.positionSecurityList.forEach(item => {
                    item.checked = false;
                });
            }
            this.setState({})
        }
    }

    // 单选
    onSimpleCheckboxClick = (checked, dataItem) => {
        dataItem.checked = !!checked;
        this.setState({})
    }

    getBatchOperate() {
        let {detailData} = this.state;
        let batchConfig = this.getBatchConfig();
        let child = batchConfig?.child || [];
        // const securityAllCount = detailData?.securityAllCount;
        const securityAllCount = detailData?.positionSecurityList?.filter(item => item.disposeStatus !== 0 && item.disposeStatus !== 3).length;
        const checkedLength = (detailData?.positionSecurityList?.length && detailData.positionSecurityList.filter(item => item.checked).length) || 0;
        let title = <>
            <div>
                <Checkbox
                    indeterminate={checkedLength > 0 && checkedLength < securityAllCount}
                    checked={checkedLength === securityAllCount}
                    onChange={(e) => this.onCheckboxClick(e.target.checked)}
                />
                {child && child.map((item, index) => {
                    return <span key={index} style={{...item.style, cursor: "pointer"}} onClick={() => item.onClick(item, this)}>{item.name}</span>
                })}
            </div>
        </>;
        return {
            title: title,
            dataIndex: "operation",
            key: "operation",
            render: (text, record) => {
                // 已忽略  跟核验通过的数据不许批量操作
                if(record.disposeStatus === 0 || record.disposeStatus === 3) {
                    return null
                }
                return (
                    <>
                        <Checkbox
                            checked={record.checked}
                            onChange={(e) => this.onSimpleCheckboxClick(e.target.checked, record)}
                        />
                    </>
                );
            }
        }
    }

    // 批量修改状态
    checkboxOperate = (status, statusName, filterStatus = [0]) => {
        const {detailData} = this.state;
        if (!detailData || !Array.isArray(detailData.positionSecurityList)) {
            message.warn('数据异常，请重试！');
            return false;
        }
        try {
            const ids = detailData.positionSecurityList.filter(item => item.checked).map(i => i.id);
            if (!ids.length) {
                message.warn('请至少选中一个问题！');
                return false;
            }
            // 已忽略状态不需要改变
            // if(filterStatus?.length) {
            //     detailData.positionSecurityList = detailData.positionSecurityList.filter(item => !filterStatus.includes(item.disposeStatus));
            // }
            detailData.positionSecurityList.map(item => {
                if (item.checked) {
                    item.disposeStatus = status !== undefined ? status : item.disposeStatus;
                    item.disposeStatusName = statusName !== undefined ? statusName : item.disposeStatusName;
                }
                return item;
            })
            this.setState({
                toggleStatus: false
            })
        } catch (error) {
            console.error('操作过程中出现错误：', error);
            message.error('操作失败，请重试！');
            return false;
        }
    }

    renderPmsDetailListButton(record) {
        let pmsDetailListBtn = getPmsDetailListBtn
        if (typeof CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.PMS_DETAIL_LIST_BTN === 'function'){
            pmsDetailListBtn=CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.PMS_DETAIL_LIST_BTN(pmsDetailListBtn)
        }
        return pmsDetailListBtn.map((item, index) => {
            return this.renderButton(record, item)
        })
    }

    pageMargin = 0;
    pagePadding = 0

    renderTable() {
        const {positionSecurityList = []} = this.state.detailData;
        let {toggleStatus} = this.state;
        const {tabKey} = this.state;
        const columns = this.getColumns();
        columns.push(this.getOperate());
        if(toggleStatus) {
            columns.pop();
            columns.push(this.getBatchOperate())
        }
        return (
            <>
                <TableTemplate
                    key={"TableTemplate" + tabKey}
                    maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                    maxHeight={this.tableHeight}
                    columns={columns}
                    dataSource={positionSecurityList}
                    onResize={(offsetHeight) => {
                        if (this.tableHeight != offsetHeight) {
                            this.tableHeight = offsetHeight;
                            this.setState({});
                        }
                    }}
                />
            </>
        )
    }

    onCancel() {
        this.setState({
            toggleStatus: false,
            visible: false
        })
    }

    refreshList() {
        const {refreshList=this.callBack} = this.props;
        refreshList(false);
        this.show(this.state.detailData.id);
    }

    renderFooter() {
        let currentItem = this.state.detailData;
        return (
            <>
                {this.renderPmsDetailBottomButton(currentItem)}
                {currentItem.remarkInfos && currentItem.remarkInfos.length > 0 ?
                    <Button onClick={() => {
                        this.setState({
                            remarkVisible: true
                        })
                    }}>查看处理意见</Button> : null}
                <Button onClick={() => {
                    this.onCancel()
                }}>关闭</Button>
                <style>{`.detail .ant-modal-footer button + button {margin-left: 8px !important;}`}</style>
            </>
        )
    }

    renderPmsDetailBottomButton(record) {
        let pmsDetailBottomBtn = getPmsDetailBottomBtn(this);
        if (typeof CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.PMS_DETAIL_BOTTOM_BTN === 'function'){
            pmsDetailBottomBtn=CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.PMS_DETAIL_BOTTOM_BTN(pmsDetailBottomBtn)
        }
        return pmsDetailBottomBtn.map((item, index) => {
            return this.renderButton(record, item)
        })
    }

    renderButton(record, item) {
        if (item.showFun && typeof item.showFun === "function" && !item.showFun(record, item, this)) return null;
        let type = item.type;
        let component = item.component;
        let Component = null;
        switch (type) {
            case 1:
                Component = component;
                return Component
            case 2:
                try {
                    Component = require(`./btnType/${component}/${component}`).default;
                } catch (e) {
                    console.log(e.toString())
                }
                if (Component) {
                    return <Component
                        {
                            ...item
                        }
                        {
                            ...this.props
                        }
                        onClick={() => item.onClick(record, item, this)}
                    />
                }
                break;
        }
    }

    renderViewRemarks() {
        return (
            <Modal
                centered={true}
                title={"处理意见"}
                visible={this.state.remarkVisible}
                maskClosable={false}
                onCancel={() => {
                    this.setState({
                        remarkVisible: false
                    })
                }}
                okButtonProps={{
                    style: {display: "none"}
                }}
                cancelText={"关闭"}
                width={600}
                destroyOnClose={true}
            >
                <Scrollbars autoHide autoHeight autoHeightMax={600}>
                    {this.state.detailData?.remarkInfos && this.state.detailData.remarkInfos.length > 0 && this.state.detailData.remarkInfos.map((item, index) => {
                        return (
                            <div key={index} style={{marginBottom: 10}}>
                                <div style={{fontWeight: "bold"}}>
                                    <span style={{marginRight: 10}}>{item.userName}</span>
                                    <span>{item.remarkTime ? formatTime(item.remarkTime) : ""}</span>
                                </div>
                                <div>{item.remark}</div>
                            </div>
                        )
                    })}
                </Scrollbars>
            </Modal>
        )
    }

    render() {
        return (
            <>
                <Modal
                    // centered={true}
                    title={"查看详情"}
                    visible={this.state.visible}
                    maskClosable={false}
                    onCancel={() => {
                        this.onCancel()
                    }}
                    className={"detail"}
                    width={1400}
                    destroyOnClose={true}
                    okText="确定"
                    footer={
                        this.renderFooter()
                    }
                >
                    <PageTemplate styleOut={{margin: "0px"}} style={{padding: "24px"}}>
                        <Scrollbars autoHide autoHeight autoHeightMax={600}>
                            <div style={{ paddingRight: "15px"}}>
                                {this.renderHeader()}
                                {this.renderTable()}
                            </div>
                        </Scrollbars>
                    </PageTemplate>
                    <style>{`.detail .ant-modal-body {padding: 0px;}`}</style>
                </Modal>
                {this.renderViewRemarks()}
                <Remark ref={ref => this.remark = ref} />
                {/*查看内容*/}
                <Preview ref={ref => this.preview = ref} typeData={this.props.typeData || this.state.typeData}/>
                {/*查看所在句子*/}
                <ViewContentText ref={ref => this.viewContentText = ref} />
            </>
        )
    }
}